import Loader from "react-loader-spinner";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { attachFile, deleteAttachment, downloadFile, getAttachmentList, keyIsLetterOrNumber, networkManager_CheckIn, networkManager_CheckOut, setErrorDialog } from "../../store/api/CommonFunctions";
import { addEditDisassembly, getDisassembly, getNextNumber } from "../store/api/DisassemblyAPI";
import { getSystemSettings } from "../../Sale/store/api/Invoice";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { CheckLg, CloudUploadFill, ColumnsGap, Command, DashCircle, Download, FileEarmarkPlus, Link45deg, List, PlusSquare, Printer, Trash } from "react-bootstrap-icons";
import NewNumberInput from "../../Components/NewNumberInput";
import { useForm } from "react-hook-form";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalCommands from "../../Components/Modals/ModalCommands";
import BihamtaTable from "../../Components/BihamtaTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import ModalInvoiceSerials from "../../Sale/Components/ModalInvoiceSerials";
import TailSpinLoader from "../../Components/TailSpinLoader";

const Disassembly = () => {
    //در این فرم به دلیل ایجاد اشکال در بروزرسانی انبار از تغییر انبار مقصد و کالای دمونتاژ شده جلوگیری شده است
    const { id } = useParams();
    const frmNewRow = useRef();
    const history = useHistory();
    const inputAttach = useRef();
    const checkOut = useRef(true);
    const dispatch = useDispatch();
    const inputAtcMoreInfo = useRef();
    const [checkedIn, setCheckedIn] = useState(true);
    const [pendingSubmit, setPendingSubmit] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [attachList, setAttachList] = useState(null);
    const { register, handleSubmit, errors } = useForm();
    const [submitError, setSubmitError] = useState(null);
    const [popSerials, setPopSerials] = useState({ show: false });
    const [disassembly, setDisassembly] = useState({ Details: [], DisassemblyNumber: 0 });
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCommand, setPopCommand] = useState({ show: false });
    const { systemSettings, defaultStorages } = useSelector(state => { return { systemSettings: state.SystemSettingsReducer.systemSettings, defaultStorages: state.SystemSettingsReducer.defaultStorages } });
    const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel", "DefaultSourceStorageHardCode"];
    let productGrouppingType = 1;
    let pDefaultSalePrice = "";
    let pDefaultSalePriceLabel = "";
    if (Array.isArray(systemSettings)) {
        productGrouppingType = Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);
        pDefaultSalePrice = systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue ?? "";
        pDefaultSalePriceLabel = systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue ?? "";
    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "مارک قطعه", colName: "ProductHolder", showInMobile: true },
        { colTitle: "نوع قطعه", colName: "ProductName", showInMobile: true, colType: "string" },
        { colTitle: "مدل قطعه", colName: "ProductModel", colType: "string" },
        { colTitle: "سریال قطعه", colName: "ProductSerial", showInMobile: false },
        { colTitle: "قیمت قطعه", colName: "ProductPrice", colType: "currency" },
        { colTitle: "توضیحات", colName: "Description", colType: "string" }
    ]
    const tableRowButtons = [
        {
            title: "حذف ردیف", type: "delete", className: "group-Btn-smalll btn-danger", onclick: removeRow
        }
    ]
    const popAttachments = (
        (<Popover id="popover-basic" style={{ maxWidth: "550px", minWidth: "530px", fontFamily: "Vazir" }}>
            <Popover.Title as="h3" className="headerStyle">
                <List size={18
                } />&nbsp;
                پیوست ها</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ color: "#2c2c71", padding: "10px" }}>
                <FormGroup>
                    <input type="file" className="form-control" ref={inputAttach} />
                    <Form.Control ref={inputAtcMoreInfo} placeholder="توضیحات(15 کاراکتر)" maxLength={15} />
                    <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={attach}><CloudUploadFill size={23} /></Button>
                </FormGroup>
                <Table responsive className="mt-2 fixedTable scrolledTable">
                    <thead>
                        <tr>
                            <th style={{ width: "15%" }}>تاریخ پیوست</th>
                            <th style={{ width: "45%" }}>نام فایل پیوست</th>
                            <th style={{ width: "25%" }}>توضیحات</th>
                            <th style={{ width: "15%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {attachList === "PENDING" &&
                            <tr>
                                <td colSpan={3} style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" color="#bb1370" width={20} height={20} /></td>
                            </tr>}
                        {
                            attachList && Array.isArray(attachList) &&
                            attachList.map((atc, i) =>
                                <tr key={i} className="resultTableRow">
                                    <td style={{ width: "20%" }}>{atc.PAttachDate}</td>
                                    <td style={{ width: "40%", direction: "ltr" }}>{atc.AttachFileName}</td>
                                    <td style={{ width: "25%", direction: "ltr" }}>{atc.MoreInfo}</td>
                                    <td style={{ width: "15%" }}>
                                        <Download size={18} color="blue" className="rowBtn" onClick={() => downloadFile(atc.ID, "DisassemblyAttachment")} />&nbsp;&nbsp;
                                        <Trash size={18} color="red" className="rowBtn" onClick={() => delAttach(atc.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
            </Popover.Content>
        </Popover>))
    function attach() {
        dispatch(attachFile(inputAttach.current, id, "DisassemblyAttachment", () => getAttachmentList(id, "DisassemblyAttachment", setAttachList), inputAtcMoreInfo.current.value));
    }
    function loadAttachList() {
        if (attachList === null) {
            getAttachmentList(id, "DisassemblyAttachment", setAttachList);
        }
    }
    function delAttach(atcID) {
        dispatch(deleteAttachment(atcID, "DisassemblyAttachment", () => getAttachmentList(id, "DisassemblyAttachment", setAttachList)));
    }
    function showModalProduct(e) {
        if (Number(id) > 0) {
            return;
        }
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key) || Number(currentRow?.ID) > 0) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setDisassembly({
                    ...disassembly,
                    ProductPrice: data.UnitPrice,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    ProductHolder: data.HolderName,
                    ProductID: data.ProductID,
                    SourceStorageID: data.StorageID,
                    SourceStorageName: data.StorageName
                })
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, invoiceType: "Sale" });

    }
    function showModalSerials() {
        const setData = (data) => {
            if (data) {
                setDisassembly({
                    ...disassembly,
                    ProductPrice: data.UnitPrice,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    ProductHolder: data.ProductHolder,
                    ProductID: data.ProductID,
                    SourceStorageID: data.StorageID,
                    SourceStorageName: data.StorageName,
                    ProductSerial: data.ProductSerial
                })
            }
        }
        setPopSerials({
            show: true,
            filterFaulty: true,
            setData: setData
        })
    }
    function showModalDetailProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key) || Number(currentRow?.ID) > 0) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setCurrentRow({
                    ProductPrice: data.UnitPrice,
                    ProductName: data.ProductName,
                    ProductModel: data.ProductModel,
                    ProductHolder: data.HolderName,
                    ProductID: data.ProductID
                })
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, invoiceType: "purchase" });
        const inputProductSerial = document.getElementById("detailProduct");
        inputProductSerial.focus();

    }
    function showAddDiv() {
        const f = async () => {
            setCurrentRow({ ID: 0 });
        }
        f().then(() => {
            const inputProductName = document.getElementById("detailProduct");
            inputProductName.focus();
        }
        );
    }
    function showModalStorage(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelectStorage = (data) => {
            if (data) {
                setDisassembly({ ...disassembly, DestinationStorageID: data.StorageID, DestinationStorageName: data.StorageName });
            }
        }
        setPopStorage({
            show: true,
            setStorageData: onSelectStorage
        })
    }
    function addNewRow(data) {

        if (disassembly.Details.some(d => d.ProductSerial === data.ProductSerial && d.ProductHolder === currentRow.ProductHolder)) {
            setErrorDialog(dispatch, "امکان ثبت دو کالا با سریال و برند یکسان وجود ندارد", "دمونتاژ");
            return;
        }
        if (disassembly.Details.some(d => Number(d.ProductID) === Number(data.ProductID))) {
            setErrorDialog(disassembly, "کالای انتخاب شده در این سطر با کالای انتخاب شده برای دمونتاژ برابر است", "دمونتاژ");
            return;
        }
        disassembly.Details.push({ ...currentRow, ProductSerial: data.ProductSerial, Index: disassembly.Details.length + 1 });
        setDisassembly({ ...disassembly })
        setCurrentRow({
            ID: 0
        });
        frmNewRow.current.reset();
        const inputProductName = document.getElementById("detailProduct");
        inputProductName.focus();

    }
    function removeRow(detail) {
        if (currentRow) {
            setCurrentRow();
        }
        if (detail.ID) {
            disassembly.Details.find(d => Number(d.ID) === Number(detail.ID)).SignedForDelete = true;
        }
        else {
            disassembly.Details = disassembly.Details.filter(d => Number(d.Index) !== Number(detail.Index));
        }
        setDisassembly({ ...disassembly });
    }
    function cancelRow() {
        setCurrentRow(null);
        setSubmitError({ ...submitError });
    }
    function onSubmit() {
        if (pendingSubmit) {
            return;
        }
        if (currentRow) {
            setCurrentRow();
        }
        if ((disassembly.ProductHolder ?? "") === "") {
            setErrorDialog(dispatch, "برند کالای انتخابی باید مشخص باشد", "ثبت فرم مونتاژ");
            return;
        }
        if ((disassembly.ProductSerial ?? "") === "") {
            setErrorDialog(dispatch, "سریال کالای انتخابی باید مشخص باشد", "ثبت/ویرایش فرم دمونتاژ");
            return;
        }
        if ((disassembly.DestinationStorageID ?? "") === "") {
            setErrorDialog(dispatch, "انبار مقصد مشخص نشده است", "ثبت/ویرایش فرم مونتاژ");
            return;
        }
        if (!(disassembly.Details?.length > 0)) {
            setErrorDialog(dispatch, "امکان ثبت فرم بدون ردیف وجود ندارد", "ثبت فرم مونتاژ");
            return;
        }
        const totalRowsPrice = disassembly.Details.filter(d => !d.SignedForDelete).map(d => Number(d.ProductPrice)).reduce((a, b) => a + b, 0);
        if (totalRowsPrice !== Number(disassembly.ProductPrice)) {
            setErrorDialog(dispatch, "جمع قیمت ردیفها باید با قیمت کالای دمونتاژ شده برابر باشد", "ثبت فرم دمونتاژ");
            return;
        }
        setPendingSubmit(true);
        const onAddEdit = (res) => {
            if (res !== "PENDING") {
                setPendingSubmit(false);
            }
            if (res.Data) {
                setErrorDialog(dispatch, "عملیات با موفقیت انجام شد", "ثبت/ویرایش فرم");
                history.replace(`/Production/Disassembly/${res.Data}`);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ثبت/ویرایش فرم");
            }
        }
        addEditDisassembly(disassembly, onAddEdit)
    }
    function gotoNew() {
        history.push(`/Production/Disassembly/0`);
    }
    function showCommand() {
        setPopCommand({
            show: true,
            attachmentType: "Disassembly",
            attachmentID: id
        })
    }
    function onClose(event) {
        event.preventDefault();
        event.returnValue = "";
        if (Number(id) > 0 && checkOut.current) {

            networkManager_CheckOut({ DocType: "Disassembly", DocID: id });
        }
        return "";
    }
    function setNetCheckIn(res) {
        if (res.Message || res.Error) {
            checkOut.current = false;
            setCheckedIn(false);
        }
        else {
            checkOut.current = true;
            setCheckedIn(true);
        }
    }
    function print(e) {
        history.push({
            pathname: `/PrintViewer/Disassembly/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DisassemblyAPI/GetDisassembly?id=${id}`,
                method: "get"
            }
        });
    }
    useEffect(() => {
        if (submitError) {
            setSubmitError(null);
        }
        setCurrentRow(null);
        setDisassembly("PENDING");
        if (!(Number(id) > 0)) {

            const onGetNumber = (res) => {
                if (res.Data) {
                    setDisassembly({ DisassemblyNumber: res.Data, Details: [] });
                }
            }
            getNextNumber(onGetNumber);
        }
        else {
            const onGet = (res) => {
                if (res.Data) {
                    window.addEventListener('beforeunload', onClose);
                    dispatch(networkManager_CheckIn({ DocType: "Disassembly", DocID: id }, setNetCheckIn));
                    setDisassembly(res.Data);
                }
            }
            getDisassembly(id, onGet);
        }
        return () => {
            window.removeEventListener('beforeunload', onClose);
            if (Number(id) > 0 && checkOut.current) {
                networkManager_CheckOut({ DocType: "Disassembly", DocID: id });
            }
        };
    }, [id]);
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-تولید";
        dispatch(getSystemSettings(settingNames));
    }, [])
    return (
        <div className="container-fluid mt-1" style={{ textAlign: "right" }}>
            <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType}
                defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} defaultStorages={defaultStorages} />
            <ModalInvoiceSerials popData={popSerials} setPopData={setPopSerials} productGrouppingType={productGrouppingType} />
            <ModalCommands popData={popCommand} setPopData={setPopCommand} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faFileAlt} size="lg" />&nbsp;
                    فرم دمونتاژ شماره {disassembly?.DisassemblyNumber ?? "0"}
                </Card.Header>
                <Card.Body className="bodyStyle">
                    {disassembly === "PENDING" &&
                        <div style={{ textAlign: "center" }}>
                            <Loader width={30} height={30} type="BallTriangle" color="#bb1370" />
                        </div>
                    }
                    {disassembly && disassembly !== "PENDING" &&
                        <Fragment>
                            <Row>
                                <Col md={3} className="form-group">
                                    <label>کالای دمونتاژ: </label>
                                    <Form.Control onKeyDown={showModalProduct}
                                        value={disassembly?.ProductName ? (disassembly.ProductHolder + "-" + disassembly.ProductName + "-" + disassembly.ProductModel) : ""} />
                                    {!Number(id) > 0 && <Button className="btn-input-tiny" onClick={showModalProduct}><List size={21} /></Button>}
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>سریال کالا:</label>
                                    <Form.Control onChange={e => setDisassembly({ ...disassembly, ProductSerial: e.target.value })} value={disassembly?.ProductSerial} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                                    <Button className="btn-input-tiny" onClick={showModalSerials}><List size={21} /></Button>
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>قیمت کالا: </label>
                                    <NewNumberInput value={disassembly?.ProductPrice ?? 0} onChange={e => setDisassembly({ ...disassembly, ProductPrice: Number(e.target.value) })} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>انبار مبدا: </label>
                                    <Form.Control value={disassembly?.SourceStorageName} readOnly={true} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <label>توضیحات: </label>
                                    <Form.Control value={disassembly?.Description} onChange={e => setDisassembly({ ...disassembly, Description: e.target.value })} />
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                {!currentRow &&
                                    <div>
                                        <Button className="group-Btn-smalll" title="ردیف جدید" onClick={showAddDiv}><PlusSquare size={25} /></Button>
                                    </div>
                                }
                                {
                                    currentRow &&
                                    <div className="rowBorder mt-1" style={{ paddingTop: "5px" }}>
                                        <form onSubmit={handleSubmit(addNewRow)} readOnly ref={frmNewRow}>
                                            <table className="flexTable">
                                                <thead>
                                                    <tr>
                                                        <th>مارک قطعه</th>
                                                        <th>نوع قطعه</th>
                                                        <th>مدل قطعه</th>
                                                        <th>سریال قطعه</th>
                                                        <th>قیمت قطعه</th>
                                                        <th>توضیحات</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <input ref={register({ required: true })} type="text" className="form-control tableRowInput" onKeyDown={showModalDetailProduct} readOnly
                                                                value={currentRow?.ProductHolder ?? ""} name="ProductHolder" />
                                                            {errors?.ProductHolder && <small className="errors">برند کالا الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <input type="hidden" value={currentRow?.Index ?? ""} readOnly name="Index" ref={register({})} />
                                                            <input type="hidden" value={currentRow?.ID ?? ""} readOnly name="ID" ref={register({})} />
                                                            <input id="detailProduct" ref={register({ required: true })} type="text" className="form-control tableRowInput" onKeyDown={showModalDetailProduct} readOnly
                                                                value={currentRow?.ProductName ?? ""} name="ProductName" />
                                                            {errors && errors.ProductName && <small className="errors">انتخاب کالا الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <input ref={register({ required: true })} type="text" className="form-control tableRowInput" onKeyDown={showModalDetailProduct} readOnly
                                                                value={currentRow?.ProductModel ?? ""} name="ProductModel" />
                                                        </td>
                                                        <td>
                                                            <input type="text" className="form-control tableRowInput" name="ProductSerial" ref={register({ required: true })} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}
                                                                onChange={e => currentRow.ProductSerial = e.target.value} />
                                                            {errors?.ProductSerial && <small className="errors">سریال کالا الزامی است</small>}
                                                        </td>
                                                        <td>
                                                            <NewNumberInput className="tableRowInput" minvalue={0} inputname="ProductPrice" value={currentRow?.ProductPrice} onChange={e => setCurrentRow({ ...currentRow, ProductPrice: e.target.value })} step={0.01} />
                                                        </td>
                                                        <td>
                                                            <input ref={register({})} type="text" className="form-control tableRowInput" defaultValue={currentRow?.Description ?? ""} name="Description" onChange={e => currentRow.Description = e.target.value} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="mt-1">
                                                <Button className="group-Btn" type="submit" variant="success"><CheckLg size={17} /> ثبت ردیف</Button>
                                                <Button className="group-Btn" variant="danger" onClick={cancelRow}><DashCircle size={17} /> انصراف</Button>
                                            </div>
                                        </form>
                                    </div>
                                }
                            </Row>
                            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} dataList={{ Data: disassembly.Details ? disassembly.Details.filter(d => !d.SignedForDelete).sort((c, d) => c.Index - d.Index) : [] }} maxHeight={500} />
                            <Col md={2} className="form-group">
                                <label>انبار مقصد:</label>
                                <Form.Control value={disassembly?.DestinationStorageName} readOnly />
                                {!(Number(id) > 0) && <Button className="btn-input-tiny" onClick={showModalStorage} style={{ top: 27, left: 2 }}><List size={23} /></Button>}
                            </Col>
                            <div className="mt-2 d-flex">
                                <Button variant="success" className="group-Btn-large d-flex gap-1" onClick={onSubmit} disabled={!checkedIn}>
                                    {pendingSubmit ? <TailSpinLoader width={18} height={18}/> : <CheckLg size={17} />}
                                    {(Number(id) > 0 ? "ویرایش " : "ثبت ") + "فرم"}
                                </Button>
                                {Number(id) > 0 &&
                                    <Fragment>
                                        <Button className="group-Btn-large d-flex gap-1" onClick={gotoNew}><FileEarmarkPlus size={18} />فرم جدید</Button>
                                        <Button className="group-Btn-large d-flex gap-1" variant="info" onClick={showCommand}><Command size={16} />دستور کار</Button>
                                        <Button className="group-Btn-large d-flex gap-1" variant="secondary" onClick={print}><Printer size={16} />چاپ فرم</Button>
                                        <OverlayTrigger trigger="click" placement="left" overlay={popAttachments} rootClose>
                                            <Button variant="light" className="group-Btn-large btn-violet  d-flex gap-1" onClick={loadAttachList}><Link45deg size={19} />پیوست ها</Button>
                                        </OverlayTrigger>
                                    </Fragment>
                                }
                            </div>
                        </Fragment>
                    }
                </Card.Body>
            </Card>
        </div>
    )
}
export default Disassembly